<template>
  <div class="main-box">
    <SharePageEmpInfo v-if="isShowEmpInfo" :empInfo="empInfo" />
    <div v-if="!errMsg" class="share-box" :class="{ 'is-show-emp-info': isShowEmpInfo }">
      <slot></slot>
    </div>
    <div v-show="errMsg" class="err-msg">{{errMsg}}</div>
  </div>
</template>

<script>
import SharePageEmpInfo from "./SharePageEmpInfo.vue";

export default {
  props: {
    empInfo: Object,
    errMsg: String,
  },
  components: { SharePageEmpInfo },
  created() {
    console.log(this.empInfo,"this.empInfo-SharePage999")
  },
  computed: {
    isShowEmpInfo() {  
     return Object.prototype.toString.call(this.empInfo) === "[object Object]" 
        && Object.keys(this.empInfo).length > 0     
    }
  },
};
</script>
        
<style scoped>
.main-box {
  width: 100%;
  height: 100vh;
  background-color: #fafafa;
  position: relative;
}
.share-box {
  width: 100%;
  height: 100%;
}
.err-msg {
  text-align: center;
  line-height: 100vh;
  font-size: 18px;
  font-weight: 600;
}
.is-show-emp-info {
  margin-top: 65px;
}
</style>
